import React from 'react';
import Field from '../../../../shared/ui/Field';
import { useFieldController } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../constants';
import { useDisabledDate } from '../../hooks/disabledDate';
import styles from './index.module.scss';

const SelectStartDate = () => {
  const { field, fieldState } = useFieldController({
    name: fieldNames.startDate,
    rules: { required: 'Укажите дату' },
  });

  const disabledDate = useDisabledDate();

  return (
    <Field.Memoized
      type={Field.types.datePicker}
      formItemLabel="Дата начала"
      required
      errorMessage={fieldState.error?.message}
      disabledDate={disabledDate}
      value={field.value}
      onChange={field.onChange}
      rootCN={styles.root}
    />
  );
};

export default SelectStartDate;
